import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
} = constants.breakpoints;
const { heading4Obj } = typographyStyles;

const core700 = constants.colors.ui.core[700];
const neutral700 = constants.colors.ui.neutral[700];
const yellow = constants.colors.brand.bisque[50];

export const challengesEarnedTokensContentCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const challengeEarnedTokenTitleCss = {
  color: neutral700,
  margin: "0 0 10px 0",
  ...heading4Obj,
};

export const challengesLinksContentCss = {
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  marginTop: "8px",

  [mediaQuery.downTo(xs)]: {
    flexDirection: "row",
    marginTop: "0px",
    justifyContent: "space-around",
  },
};

export const challengesLinkCss = {
  color: core700,
  fontWeight: "400",
  lineHeight: "100%",
};

export const challengesTokensAmountEarnedContent = (isStudent) => ({
  height: isStudent ? "185px" : "57px",
  width: "100%",
  backgroundColor: yellow,
  borderRadius: "8px",
  padding: isStudent ? "28px 16px 24px 16px" : "16px 12px 24px 12px",
  marginTop: "16px",

  [mediaQuery.downTo(xs)]: {
    height: isStudent ? "115px" : "57px",
    gap: "24px",
    justifyContent: "center",
  },
});
